import FormContainer from 'components/Form/FormContainer.vue';
import FormTextInput from 'components/Form/FormTextInput.vue';
import FormTextAreaInput from 'components/Form/FormTextAreaInput.vue';
import FormListInput from 'components/Form/FormListInput.vue';
import FormDateInput from 'components/Form/FormDateInput.vue';
import FormBoolInput from 'components/Form/FormBoolInput.vue';
import FormSelectInput from 'components/Form/FormSelectInput.vue';
import FormTimeInput from 'components/Form/FormTimeInput.vue';
import FormDateTimeInput from 'components/Form/FormDateTimeInput.vue';
import FormWrapper from 'components/Form/FormWrapper';
import FormNumericInput from 'components/Form/FormNumericInput.vue';
import FormSlotInput from 'components/Form/FormSlotInput.vue';
import FormColorInput from 'components/ColorPicker.vue';
import FormReportListInput from 'components/Form/FormReportListInput.vue';
import FormPriceInput from 'components/Form/FormPriceInput.vue';

export default {
  components: {
    'list-input': FormListInput,
    'form-container': FormContainer,
    'text-input': FormTextInput,
    'textarea-input': FormTextAreaInput,
    'date-input': FormDateInput,
    'bool-input': FormBoolInput,
    'select-input': FormSelectInput,
    'time-input': FormTimeInput,
    'datetime-input': FormDateTimeInput,
    'form-wrapper': FormWrapper,
    'numeric-input': FormNumericInput,
    'slot-input': FormSlotInput,
    'color-input': FormColorInput,
    'report-list-input': FormReportListInput,
    'price-input': FormPriceInput
  }
};
